var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-slide-y-reverse-transition',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"buscador":_vm.buscador,"categoriaSeleccionada":_vm.categoriaSeleccionada,"vendedorSeleccionado":_vm.vendedorSeleccionado}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }